import { configureStore } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/react';
import { reducer as formReducer } from 'redux-form';
import authMiddleware from '../modules/authMiddleware';

import { api } from './apiSlice';
import { rtkQueryErrorLogger } from './errorMiddleware';

import authReducer from './slices/authSlice';

const sentryReduxEnhancer = Sentry.createReduxEnhancer();

function getStore(props) {
  const initialState = {};

  const store = configureStore({
    preloadedState: initialState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(
        api.middleware,
        rtkQueryErrorLogger,
        authMiddleware
      ),
    reducer: {
      [api.reducerPath]: api.reducer,
      auth: authReducer,
      form: formReducer,
    },
    enhancers: (getDefaultEnhancers) => [...getDefaultEnhancers(), sentryReduxEnhancer],
  });
  return store;
}

export default getStore;
